import { render, staticRenderFns } from "./_category.vue?vue&type=template&id=927eb67e&scoped=true"
import script from "./_category.vue?vue&type=script&lang=js"
export * from "./_category.vue?vue&type=script&lang=js"
import style0 from "./_category.vue?vue&type=style&index=0&id=927eb67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927eb67e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShimmerEffect: require('/workspace/components/ShimmerEffect.vue').default,ActivityCard: require('/workspace/components/ActivityCard.vue').default})
